'use client'

import ShareButton from '@/app/(pages)/profile/(with-container)/(sidebar-layout)/refer/ShareButton';
import useSetSearchParams from '@/hooks/useSetSearchParams';
import getNextDate from '@/utils/getNextDay';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format } from 'date-fns';
import { motion } from 'framer-motion';
import moment from 'moment';
import { useParams, usePathname } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { DateValueType } from '@/types/common'; 
import Favorite from '../../(details)/Favourite';
import NavigateToSearchPage from './NavigateToSearchPage';
import Button from '@/components/ui/Button';
import dynamic from 'next/dynamic';
const DatePickerModal = dynamic(() =>
    import('@/components/ui/DatePicker').then((mod) => mod.DatePickerModal)
)

export default function MobileHeader({ hotelData }: { hotelData: any }) {


    const [activeSection, setActiveSection] = useState('details')

    const { getSearchParamsString } = useSetSearchParams()
    const pathname = usePathname()

    const urlParams = useParams()

    const { setSearchParam } = useSetSearchParams();

    const { params } = useSetSearchParams();
    const { checkIn = getNextDate(0), checkOut = getNextDate(1), } = params;
    const { passenger, city, } = params;

    const checkInTime = useMemo(() => {
        const date = moment(checkIn).format("llll").split(" ");
        return `${date[1]} ${date[2].split(',')[0]}`;
    }, [checkIn]);

    const checkOutTime = useMemo(() => {
        const date = moment(checkOut).format("llll").split(" ");
        return `${date[1]} ${date[2].split(',')[0]}`;
    }, [checkOut]);

    const [values, setValues] = useState<(Date | null)[]>([new Date(getNextDate(1)), new Date(getNextDate(2))]);

    useEffect(() => {
        setValues([new Date(checkIn), new Date(checkOut)]);
    }, [checkIn, checkOut]);

    const handleSubmitDate = async () => {

        let hasError = false;
        let NewErrors = { date: "", passenger: "" };

        if (!values || !values[0] || !values[1]) {
            NewErrors.date = "Please select a date";
            hasError = true;
            return
        }

        setSearchParam([
            { checkIn: format(values[0], "yyyy-MM-dd") || "" },
            { checkOut: values[1] ? format(values[1], "yyyy-MM-dd") : "" },
        ]);
        scrollToElementById('rooms')
    };

    function scrollToElementById(elementId: string) {
        const element = document.getElementById(elementId);

        if (element) {
            // Get the element's top position relative to the document
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            // Scroll with a smooth behavior and apply the offset
            window.scrollTo({
                top: elementPosition - 130,
                behavior: 'smooth'
            });
        } else {
            console.error(`Element not found with id: ${elementId}`);
        }
    }

    const handleValueChange = (newValue: DateValueType) => {
        setValues([
            newValue?.startDate ? new Date(newValue.startDate) : null,
            newValue?.endDate ? new Date(newValue.endDate) : null
        ]);
    };

    return (
        <div>
            <div className='h-[60px] md:hidden'>

            </div>
            <motion.div
                className='fixed top-0 left-0 z-[600] bg-[#f9fafb] w-full shadow lg:hidden'>
                <div className='px-4 py-2.5 flex items-center justify-between'>
                    <div className='grid grid-cols-[24px,_1fr] gap-2 items-center'>
                        <NavigateToSearchPage
                            country={urlParams.country as string}
                            isSmartButton
                            lat={params.lat}
                            lng={params.lng}
                            checkIn={params.checkIn}
                            checkOut={params.checkOut}
                            passenger={params.passenger}
                            city={urlParams.city as string}>
                            <FontAwesomeIcon icon={faChevronLeft}
                                className='justify-self-center place-self-center text-neutral-800' />
                        </NavigateToSearchPage>
                        <div>
                            <p className='text-sm line-clamp-1 font-semibold text-gray-800'>{hotelData.name}</p>
                            <DatePickerModal
                                applyButton={<div className='w-full pb-4 pt-2 flex items-center justify-center'>
                                    <Button color='secondary' radius='rounded-full'
                                        onClick={handleSubmitDate} className='w-full'>
                                        Apply
                                    </Button>
                                </div>}
                                preventAutoClose
                                showOneMonth
                                buttonProps={{ className: '' }}
                                values={{ startDate: values[0], endDate: values[1] }}
                                onChange={handleValueChange}>
                                <button className='text-start'>
                                    <span className='text-sm text-neutral-800 font-semibold'>{hotelData.name.content}</span>
                                    <div className='text-indigo-500 flex items-center gap-1'>
                                        <span className='text-[10px]'>{checkInTime} - {checkOutTime}</span>
                                        <FontAwesomeIcon icon={faChevronDown} size='xs' />
                                    </div>
                                </button>
                            </DatePickerModal>

                        </div>
                    </div>

                    <div className='flex items-center text-neutral-600 gap-4'>
                        <Favorite hotelId={hotelData.id} />
                        <ShareButton content={`${pathname}/${getSearchParamsString()}?`}>
                            <FontAwesomeIcon icon={faShareNodes} />
                        </ShareButton>
                    </div>
                </div>
                {/* <div className='flex items-end justify-around border-b  mt-2'>
                            <button onClick={() => handleActive('details')}
                                className={`${activeSection === 'details' ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b`}>
                                Details
                            </button>
                            <button onClick={() => handleActive('rooms')}
                                className={`${activeSection === 'rooms' ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b`}>
                                Rooms
                            </button>
                            <button onClick={() => handleActive('reviews')}
                                className={`${activeSection === 'reviews' ? 'text-indigo-500 border-indigo-500' : 'border-white text-neutral-400'} pb-1 text-xs border-b`}>
                                Reviews
                            </button>
                        </div> */}
            </motion.div>
        </div>
    );
}